import React from 'react'
import { string } from 'prop-types'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import GenericDropdown from '../../generic-dropdown.jsx'
import { FormattedMessage } from 'react-intl'

const CrmSaleChannelSelect = props => {
  const variables = {}
  const qlq = gql`
    {
      departments {
        department_uid
        name
        kind
      }
    }
  `
  return (
    <Query query={qlq} variables={variables}>
      {({ loading, error, data, refetch }) => {
        const options =
          data && data.departments
            ? data.departments.map(v => ({
                ...v,
                value: v.department_uid
              }))
            : []
        return (
          <GenericDropdown
            {...props}
            options={options}
            placeholder={
              props.placeholder ? (
                props.placeholder
              ) : (
                <FormattedMessage
                  id="crm.ui.dropdown.select_sale_channel"
                  defaultMessage="Select Sale Channel"
                />
              )
            }
          />
        )
      }}
    </Query>
  )
}

CrmSaleChannelSelect.propTypes = {
  placeholder: string
}

export default CrmSaleChannelSelect
